<template>
  <BCard v-if="enrollment">
    <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <vSelectValidated vsName="Student" :vsModel.sync="enrollment.student" :vsDisabled="true" :vsOptions="students" vsLabel="search_name" vsMd="6" vsRequired vsRules="required" @vsOnSearch="changedStudentsQuery"/>
                    <vSelectValidated vsName="Course" :vsModel.sync="enrollment.course" :vsDisabled="true" :vsOptions="courses" vsLabel="search_name" vsMd="6" vsRequired vsRules="required" @vsOnInput="changedCourse"  @vsOnSearch="changedCoursesQuery"/>
                    <DatepickerValidated vsName="Start date" :vsModel.sync="enrollment.start_date" vsMd="6" vsRequired vsRules="required" :vsMin="enrollment.course ? minDateEnrollment : ''" />
                    <DatepickerValidated vsName="End Date" :vsModel.sync="enrollment.end_date" vsMd="6" :vsMin="minDateEndEnrollment" vsReset />
                    <DatepickerValidated vsName="Próxima renovación" :vsModel.sync="enrollment.expiration_date" vsMd="6" vsRequired />
                    <vSelectValidated vsName="Sucursal" v-if="groups && groups.length>1" vsRequired vsRules="required" :vsModel.sync="enrollment.group_id" :vsOptions="groups" :vsReduce="gr=>gr.id" vsLabel="name" vsMd="6" :vsDisabled="(enrollment.course && enrollment.course.group_id) ? true : false"/>

                    
                    <BCol cols="12" v-if="cursoMensual"><p>Curso de pago mensual:</p></BCol>
                    <BCol cols="12"><div v-if="cursoMensual">* Si no cubres los siguientes campos, se cobrarán los importes por defecto del curso</div></BCol>
                    <NumberInputValidated v-if="cursoMensual"  vsName="Mensualidad estándar para este alumno/a (opcional)"  vsMd="6" :vsModel.sync="enrollment.monthly_payment"/>
                    <div class="w-100"></div>
                    <NumberInputValidated v-if="cursoMensual"  vsName="Pago primer mes para este alumno/a (opcional)"  vsMd="6" :vsModel.sync="enrollment.first_month_payment"/>
                    <NumberInputValidated v-if="cursoMensual" vsName="Pago último mes para este alumno/a (opcional)"  vsMd="6"  :vsModel.sync="enrollment.last_month_payment"/> 
                    
                    <BCol cols="12" v-if="!cursoMensual && enrollment.course"><p>Curso de pago a plazos. Plazos a pagar</p></BCol>
                    
                    <BCol>
                        <BRow v-for="(term, index) in termsToPay" :key="index" class="border rounded p-1 mb-1">
                            <BCol cols="12"> 
                                <BRow> 
                                    <BCol> 
                                        <p>Plazo {{ index+1 }}</p> 
                                    </BCol> 
                                </BRow>
                            </BCol>

                            <BCol>
                                <BRow>
                                    <DatepickerValidated vsName="Start date" :vsDisabled="true" :vsModel.sync="term.start_date" vsMd="6" vsRequired vsRules="required" />
                                    <NumberInputValidated vsName="Amount" :vsDisabled="true" :vsModel.sync="term.term_payment" vsMd="6" vsRequired vsRules="required"/>
                                </BRow>
                            </BCol> 
                        </BRow>
                    </BCol>

             </BRow>

                <!-- Action Buttons -->
                <BButton variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'enrollments' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
  </BCard>
</template>

<script>
import { BButton, BForm, BRow, BCol, BFormInput, BFormInvalidFeedback, BFormDatepicker, BFormGroup, BCard } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { alpha_num, required } from 'vee-validate/dist/rules';
import { computed, inject } from '@vue/composition-api';
import formValidation from '@core/comp-functions/forms/form-validation'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import popups from '@/hooks/popups';
import vSelect from 'vue-select'
import store from '@/store';
import { watch, ref } from '@vue/composition-api';
import axios from '@axios'

export default {
    components: { DatepickerValidated, NumberInputValidated, TextInputValidated, vSelectValidated, BButton, BForm, BRow, BCol, BFormInput, BFormInvalidFeedback, BFormDatepicker, BFormGroup, vSelect, ValidationObserver, ValidationProvider, BCard },
    emit: ['changed-query'],

    setup(props, ctx){
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const enrollment = inject('enrollment')
        const students = inject('students')
        const courses = inject('courses')
        const terms = inject('terms')
        const groups = inject('groups')


        const minDateEnrollment=ref(null)
        const minDateEndEnrollment=ref(null)

        const enrollmentStartPayment=ref(null);
        const cursoMensual=ref(false);
        const termsToPay=ref([])
        const termsCourse=ref([])

        const studentsQuery = inject('studentsQuery')
        const coursesQuery = inject('coursesQuery')

        extend('required', required)
        extend('alpha_num', alpha_num)

        const onSubmit = function() {
            this.$refs.form.validate().then(success => {
                if(success) {
                    enrollment.value.student_id = enrollment.value.student.id
                    enrollment.value.course_id=enrollment.value.course.id
                    store.dispatch('enrollments/updateEnrollment', JSON.parse(JSON.stringify(enrollment.value)))
                        .then(response => { 
                            if (response.data.success) {
                                this.$router.push({ name: 'enrollments' }) 
                            }
                            
                        })
                        .catch(error => {
                            errorToast('Can\'t update enrollments')
                        })
                }
            })
        }

        const changedStudentsQuery= function (val) {
            studentsQuery.value=val
            ctx.emit("changed-query")
        }

        const changedCoursesQuery= function (val) {
            coursesQuery.value=val
            ctx.emit("changed-query")
        }
        

        const getInfo=() => {
            if (enrollment.value.start_date) {
                minDateEndEnrollment.value= new Date(enrollment.value.start_date)
                minDateEndEnrollment.value.setDate(minDateEndEnrollment.value.getDate() - 1)
                minDateEndEnrollment.value=minDateEndEnrollment.value.toISOString().split("T")[0];
            }


            
            

            if (enrollment.value.course) {
                termsToPay.value=[]
                termsCourse.value=[]

                if (enrollment.value.course.monthly_payment) {
                    cursoMensual.value=true;
                    minDateEnrollment.value= new Date(enrollment.value.course.start_date)
                    minDateEnrollment.value.setDate(minDateEnrollment.value.getDate()-1)
                    minDateEnrollment.value=minDateEnrollment.value.toISOString()
                } else {
                    cursoMensual.value=false;
                    terms.value.forEach(term => {
                        if (term.course_id==enrollment.value.course.id) {

                            termsCourse.value.push(term);
                            minDateEnrollment.value=new Date(termsCourse.value[0].start_date)
                            minDateEnrollment.value.setDate(minDateEnrollment.value.getDate()-1)
                            minDateEnrollment.value=minDateEnrollment.value.toISOString()
                            
                            // Terms to pay
                            if (enrollment.value.start_date) {
                                let dateNow=new Date(Date.now()).toISOString()
                                if ((term.start_date<=enrollment.value.start_date) && (term.start_date <= dateNow.substring(0, dateNow.indexOf('T')))) {
                                    termsToPay.value.push(term) 
                                } 
                            }   
                        }
                    });    
                }

                if (enrollment.value.course.group_id) {
                    enrollment.value.group_id=enrollment.value.course.group_id
                }
            }
        }


        watch(enrollment, () => {             
            getInfo()
        }, {deep:true})


        

        const minDate = computed(() => {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today)
            return minDate
        })

        const changedCourse= () => {
            enrollment.value.group_id=null
            enrollment.value.end_date=enrollment.value.course.end_date
            enrollment.value.last_month_payment=enrollment.value.course.last_month_payment 
            if (new Date(enrollment.value.start_date).getMonth()>new Date(enrollment.value.course.start_date).getMonth() || new Date(enrollment.value.start_date).getYear()>new Date(enrollment.value.course.start_date).getYear()) {
                    enrollment.value.first_month_payment=enrollment.value.course.monthly_payment
                } else if (enrollmentStartPayment.value!=null) {
                    enrollment.value.first_month_payment=enrollment.value.course.first_month_payment
                } else {
                    enrollment.value.first_month_payment=enrollment.value.course.first_month_payment
                }
        }

        if (enrollment.value) {
            if (enrollment.value.course) {
                enrollment.value.end_date=enrollment.value.course.end_date
                enrollment.value.last_month_payment=enrollment.value.course.last_month_payment
            }
        } 

        return {
            getValidationState,
            onSubmit,
            enrollment,
            minDate,
            students,
            courses,
            minDateEnrollment,
            cursoMensual,
            termsToPay,
            changedCourse,
            changedStudentsQuery, 
            changedCoursesQuery,
            minDateEndEnrollment,
            groups
        }
    }

}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
